import { t } from '@lingui/macro';
import { format } from '~/app/shared/util/utilities/date';
import { EntryTransactionsColumns, LedgerLinesFilter } from './types';
import { DimensionsQueryResponse } from '../../dimensions/hooks/useDimensions';

export function getExportHeadings(agreement, filterState: LedgerLinesFilter) {
    return [
        '',
        `${agreement.number} - ${agreement.name}`,
        `${t`Show transactions`} »`,
        buildTableFiltersDescription(filterState),
    ];
}

export function getExportColumns(
    hasDimension: boolean,
    baseCurrency: string,
    currency: string,
    hasAccessProjectUser: boolean,
    dimensionsQuery: DimensionsQueryResponse
) {
    const hasCurrencyFilter = currency !== 'Converted';
    const columns = [
        {
            accessor: EntryTransactionsColumns.Type,
            columnHeader: t`Type`,
        },
        {
            accessor: EntryTransactionsColumns.Account,
            columnHeader: t`Account`,
        },
        {
            accessor: EntryTransactionsColumns.CustomerSupplier,
            columnHeader: t`Customer/Supplier`,
        },
        {
            accessor: EntryTransactionsColumns.Text,
            columnHeader: t`Text`,
        },
        {
            accessor: EntryTransactionsColumns.VatCode,
            columnHeader: t`VAT`,
        },
        {
            accessor: EntryTransactionsColumns.Currency,
            columnHeader: t`Currency`,
        },
        {
            accessor: EntryTransactionsColumns.Amount,
            columnHeader: t`Amount`,
        },
        {
            accessor: EntryTransactionsColumns.BalanceInDKK,
            columnHeader: `${t`Amount`} (${hasCurrencyFilter ? currency : baseCurrency})`,
        },
        {
            accessor: EntryTransactionsColumns.CalculatedBalance,
            columnHeader: `${t`Balance`} (${hasCurrencyFilter ? currency : baseCurrency})`,
        },
    ];

    if (hasAccessProjectUser) {
        columns.push({
            accessor: EntryTransactionsColumns.Project,
            columnHeader: t`Project`,
        });
    }

    if (hasDimension) {
        const dimension1 = dimensionsQuery.data?.find(d => d.id === 1);
        const dimension2 = dimensionsQuery.data?.find(d => d.id === 2);
        const dimension3 = dimensionsQuery.data?.find(d => d.id === 3);

        if (dimension1) {
            columns.push({
                accessor: EntryTransactionsColumns.Dimension1,
                columnHeader: dimension1.name,
            });
        }

        if (dimension2) {
            columns.push({
                accessor: EntryTransactionsColumns.Dimension2,
                columnHeader: dimension2.name,
            });
        }

        if (dimension3) {
            columns.push({
                accessor: EntryTransactionsColumns.Dimension3,
                columnHeader: dimension3.name,
            });
        }
    }

    return columns;
}

const buildTableFiltersDescription = (filterState: LedgerLinesFilter) =>
    t`Ledger card for the period ${filterState.date ? format(filterState.date, 'dd-mm-yy') : ''}`;
